import React from 'react'
import * as Yup from 'yup'
import { withFormik } from 'formik'
import { Input, TextErrorInput, Button } from '@provi/provi-components'
import { Form } from '../../../components/form'

export const Formik = props => {
  const { handleChange, values, errors, touched, handleBlur, handleSubmit } = props

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        autoFocus
        margin="normal"
        id="name"
        placeholder="Escreva aqui"
        onChange={handleChange('decisionMoney')}
        onBlur={handleBlur('decisionMoney')}
        error={!!errors.decisionMoney}
        value={values.decisionMoney}
      />
      {errors.decisionMoney && touched.decisionMoney && <TextErrorInput text={errors.decisionMoney} />}

      <Button
        marginHorizontal={0}
        type="submit"
        disabled={errors.decisionMoney || !values.decisionMoney}
        text="Avançar"
        persistFloatingMode={false}
      />
    </Form>
  )
}

export const FormFomik = withFormik({
  validateOnBlur: false,
  validateOnChange: true,
  enableReinitialize: true,
  mapPropsToValues: props => ({ decisionMoney: props.data || '' }),
  validationSchema: Yup.object().shape({
    decisionMoney: Yup.string()
      .min(2, 'A resposta deve conter no mínimo 2 caracteres')
      .max(2048, 'A resposta deve conter no máximo 2048 caracteres')
      .required('Digite um texto válido')
  }),
  handleSubmit: async ({ decisionMoney }, { setSubmitting, props }) => {
    props.goToNextScreen(decisionMoney)
    setSubmitting(false)
  }
})(Formik)
